import Storage from '../../../lib/Storage'

export const getUser = () => {
  const user = Storage().getObject('user')
  return user
}
